import styled from 'styled-components';

export const CargoListItem = styled.li`
    display: grid;
    grid-template-columns: 4px 120px 200px 20px auto;
    gap: 10px;
    align-items: center;
    min-height: 30px;
`;

export const IndexNumber = styled.span`
    font-weight: bold;
`;

export const TradeName = styled.span`
    overflow: hidden;
`;

export const CommodityBookLink = styled.a`
    display: inline-flex;
    align-items: center;
    padding: 0 8px;
`;

export const FosfaStatus = styled.div`
    white-space: nowrap;
`;
